<template>
  <GwMenu
    ref="gwmenu"
    :placement="menuPosition"
    :flOptions="{ offset: 0, padding: 0 }"
  >
    <template #opener>
      <div
        class="csst mdi icon_btn traresmenu_opener clr-grey"
        :class="iconOpener"
        @mouseenter="
          e =>
            fl_positionTooltip(e, {
              offset: 4,
              strategy: 'absolute',
              placement: tooltipPosition,
            })
        "
      >
        <div
          class="csst_content text-nowrap clr-white"
          v-html="$t('trainer.trainer_result_view')"
        ></div>
      </div>
    </template>
    <template #default="{ methods }">
      <div
        class="gw_menu"
        style="--width: auto; max-height: var(--vh-10); overflow: auto"
        @click="methods.toggleOpen(false)"
      >
        <TrainerResultChartSwitcher />
      </div>
    </template>
  </GwMenu>
</template>

<script>
import GwMenu from '@/components/lib/GwMenu'
import TrainerResultChartSwitcher from '@/components/Trainer/TrainerResultChartSwitcher'
import float_mix from '@/mixins/float_mix'

export default {
  name: 'TrainerResultChartSwitcherMenu',
  components: {
    TrainerResultChartSwitcher,
    GwMenu,
  },
  mixins: [float_mix],
  props: {
    iconOpener: { default: () => 'mdi-dots-vertical' },
    menuPosition: { default: () => 'right-start' },
    tooltipPosition: { default: () => 'right' },
  },
}
</script>
<style lang="scss" scoped>
.traresmenu {
  display: flex;
  --opener-size: 1.5rem;
  &_opener {
    height: 2rem;
    width: 2rem;
    font-size: var(--opener-size);
  }
}
</style>
